import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContactsService } from '../../store/services/contacts.service';
import { IContact } from '../../store/models/contact.model';
import { Store } from '@ngrx/store';
import { EReducers, IReducers } from '../../store/reducers';
import { takeUntil } from 'rxjs/operators';
import { EMessageStateStatus, IMessage, IMessageState } from '../../store/models/message.model';
import { Subject } from 'rxjs';
import { viewMessage } from '../../store/actions/message.action';
import { IUserSessionData } from '../../store/models/user.model';
import { SessionService } from '../../store/services/session.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-inactive-add-contact',
  templateUrl: './inactive-add-contact.component.html',
  styleUrls: ['./inactive-add-contact.component.scss'],
})
export class InactiveAddContactComponent implements OnInit, OnDestroy {

  contactId: number;
  messageId: number;
  contactData: IContact;
  messages: IMessage[];
  sessionData: IUserSessionData;
  inputForm: FormGroup;
  formReady: boolean;

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly contactsService: ContactsService,
    private readonly store$: Store<IReducers>,
    private readonly sessionService: SessionService,
  ) {
  }

  ngOnInit(): void {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;
        if (this.contactId) {
          this.contactsService.viewContact(this.contactId)
            .subscribe(contact => {
              this.contactData = contact;
              this.inputForm.addControl('group_id', new FormControl(this.contactData.group_id, [Validators.required]));
              this.inputForm.addControl('firstname', new FormControl(''));
              this.inputForm.addControl('lastname', new FormControl(''));
              this.inputForm.addControl('email', new FormControl('', [Validators.required,Validators.email]));
              this.inputForm.addControl('company', new FormControl(this.contactData.company));
              this.inputForm.addControl('company_address', new FormControl(this.contactData.company_address));
              this.inputForm.addControl('company_state', new FormControl(this.contactData.company_state));
              this.inputForm.addControl('company_zip', new FormControl(this.contactData.company_zip));
              this.inputForm.addControl('company_country', new FormControl(this.contactData.company_country));
              this.inputForm.addControl('company_url', new FormControl(this.contactData.company_url));
              this.formReady = true;
              this.store$
                .select(EReducers.MESSAGE)
                .pipe(takeUntil(this.destroy$))
                .subscribe((state: IMessageState) => {
                  if (state.status === EMessageStateStatus.READY) {
                    this.messages = state.current_messages;
                  }
                });

              this.store$.dispatch(
                viewMessage({
                  id_message: this.messageId || this.contactData.message_id,
                }),
              );
            });
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

}
